import { Attachment } from '@vex/model/attachment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { tap, finalize, share } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AttachmentService {

  baseUrl = environment.API_URL;
  errorData: {};
  readonly baseEndpoint = 'Attachment';

  private cache: any = <any>{};
  private cachedObservable: Observable<any> = <Observable<any>>{};

  constructor(private http: HttpClient) {
  }

  getPaginatedData(filter : any): Observable<any> {
    let url = this.baseUrl + this.baseEndpoint + '/GetPaginated';
    return this.http.post<any>(url, filter);
  }

  getAttachmentGetByReferenceId(Id: string): Observable<Attachment[]> {
    return this.http.get<Attachment[]>(this.baseUrl + this.baseEndpoint + '/GetByReferenceId/' + Id);
  }

  getAttachmentGetById(Id: string): Observable<Attachment> {
    const attachmentId = this.normalizeAttachmentId(Id);
    if (!attachmentId) {
      return throwError(new Error('A valid attachment id is required.'));
    }

    let observable: Observable<any>;
    if (this.cache[attachmentId]) {
      observable = of(this.cache[attachmentId]);
    }  else if (this.cachedObservable[attachmentId]) {
      observable = this.cachedObservable[attachmentId];
    } else {
      this.cachedObservable[attachmentId] = this.http.get<Attachment>(
        this.baseUrl + this.baseEndpoint + '/GetById/' + encodeURIComponent(attachmentId))
        .pipe(
          tap(res => this.cache[attachmentId] = res),
          share(),
          finalize(() => this.cachedObservable[attachmentId] = null)
        );
      observable = this.cachedObservable[attachmentId];
    }
    return observable;
  }

  /** Validates the attachment ID accepted by the Attachment API. */
  private normalizeAttachmentId(value: string): string | null {
    const normalized = typeof value === 'string' ? value.trim() : '';
    return /^[a-f\d]{24}$/i.test(normalized) ? normalized : null;
  }

  addAttachment(formData: any) {
    return this.http.post(this.baseUrl + this.baseEndpoint + '', formData, {
        reportProgress: true,
        observe: 'events'
    });
  }
  
  removeAttachment(Id: string) {
    return this.http.delete(this.baseUrl + this.baseEndpoint + '/' + Id);
  }

  downloadAttachmentByAttachmentId(Id: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + this.baseEndpoint + '/DownloadAttachmentByAttachmentId/' + Id);
  }

  getFile(path: string = '', deviceId: string = ''): Observable<any> {
    let observable: Observable<any>;
    if (this.cache[path]) {
      observable = of(this.cache[path]);
    }  else if (this.cachedObservable[path]) {
      observable = this.cachedObservable[path];
    } else {
      let url = this.baseUrl + this.baseEndpoint + '/DownloadAttachment';
      this.cachedObservable[path] = this.http.post<any>(url, {Path: path, DeviceId: deviceId})
        .pipe(
          tap(res => this.cache[path] = res),
          share(),
          finalize(() => this.cachedObservable[path] = null)
        );
      observable = this.cachedObservable[path];
    }
    return observable;
  }
}
